<template>
    <div class="chart-container" ref="chartContainer"></div>
</template>

<script>
export default {
    name: 'UserChart',
    data() {
        return {
            myChart: null
        }
    },
    props: {
        chartData: {
            type: Object,
            default: () => ({ time: [], earnings: [], ratio:[] })
        }
    },
    mounted() {
        this.initChart();
        if (this.chartData && this.chartData.time && this.chartData.earnings) {
            this.createChartData();
        }
    },
    beforeDestroy() {
        if (this.myChart) {
            this.myChart.dispose();
            this.myChart = null;
        }
    },
    watch: {
        chartData: {
            handler(newData) {
                if (newData && newData.time && newData.earnings) {
                    this.createChartData();
                }
            },
            deep: true,
            immediate: false
        }
    },
    methods: {
        initChart() {
            if (!this.$echarts) {
                console.error('ECharts 未正确引入');
                return;
            }
            this.myChart = this.$echarts.init(this.$refs.chartContainer);
            window.addEventListener('resize', this.handleResize);
        },

        handleResize() {
            if (this.myChart) {
                this.myChart.resize();
            }
        },

        createChartData() {
            if (!this.myChart) {
                this.initChart();
            }

            const option = {
                tooltip: {
                    axisPointer: {
                        type: 'cross'
                    },
                    trigger: 'axis',
                    formatter: function(params) {
                        const data = params[0].data;
                        return `时间: ${params[0].name}<br/>资产: ${data.earnings}<br/>百分比：${data.value}%`;
                    }
                },
                backgroundColor: "#2a2d2e",
                textStyle: {
                    color: "#a8a7a9"
                },
                grid: {
                    left: '3%',
                    right: '3%',
                    bottom: '3%',
                    top: '3%',
                    containLabel: true
                },
                dataZoom: [{
                    type: "inside",
                    start: 0,
                    end: 100
                }],
                xAxis: {
                    type: 'category',
                    data: this.chartData.time,
                    show: false,
                    boundaryGap: false
                },
                yAxis: {
                    name: "收益",
                    type: "value",
                    show: false,
                    axisLabel: {
                        formatter: "{value}"
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#5a595a'
                        }
                    }
                },
                series: [{
                    type: "line",
                    name: "收益",
                    data: this.chartData.time.map((time, index) => {
                            return {
                            value: this.chartData.ratios[index],
                            earnings: this.chartData.earnings[index]
                            };
                            }),
                    symbol: 'none',
                    smooth: true,
                    lineStyle: {
                        width: 2,
                        color: '#5470c6'
                    },
                    areaStyle: {
                        color: {
                            type: 'linear',
                            x: 0, y: 0, x2: 0, y2: 1,
                            colorStops: [{
                                offset: 0, color: 'rgba(84, 112, 198, 0.5)'
                            }, {
                                offset: 1, color: 'rgba(84, 112, 198, 0.1)'
                            }]
                        }
                    }
                }]
            };

            this.myChart.setOption(option);
        }
    }
}
</script>

<style lang="scss" scoped>
.chart-container {
    width: 100%;
    height: 100%;
    background-color: #2a2d2e;
}
</style>